import { toBlob } from 'html-to-image';

export const exportReferralCardToPng = async (node) => {
    if (!node) {
        throw new Error('exportReferralCardToPng: missing node');
    }
    if (typeof document !== 'undefined' && document.fonts?.ready) {
        await document.fonts.ready;
    }
    const rect = node.getBoundingClientRect();
    const width = Math.ceil(rect.width) || node.offsetWidth;
    const height = Math.ceil(rect.height) || node.offsetHeight;
    const blob = await toBlob(node, {
        pixelRatio: 2,
        cacheBust: true,
        width,
        height,
        style: {
            position: 'static',
            top: 'auto',
            left: 'auto',
            transform: 'none',
        },
    });
    if (!blob) {
        throw new Error('exportReferralCardToPng: toBlob returned null');
    }
    return blob;
};

export const getInviteCodeFromLink = (link) => {
    if (!link) {
        return '';
    }
    try {
        const decoded = decodeURIComponent(link);
        const parts = decoded.split('/').filter(Boolean);
        return parts[parts.length - 1] || '';
    } catch {
        return '';
    }
};

export const buildQrFilename = (referralLink) => {
    const code = getInviteCodeFromLink(referralLink);
    return code ? `paysend-referral-qr-${code}.png` : 'paysend-referral-qr.png';
};
